import { FC } from "react";
import InnerPage from "../../shared/components/InnerPage";
import YouTubeEmbed from "../../shared/components/YouTubeEmbed";
import { PATHS } from "../../paths";
import { Training } from "./trainings";

interface TrainingDetailPageProps {
  training: Training;
}

const TrainingDetailPage: FC<TrainingDetailPageProps> = ({ training }) => (
  <InnerPage
    eyebrow="Eğitimlerimiz"
    title={training.title}
    crumbs={[{ label: "Eğitimlerimiz", to: PATHS.trainings }, { label: training.cardTitle }]}
    seoDescription={training.seoDescription}
    withSidebar
  >
    <div className="it-prose">
      <h2>{training.title}</h2>
      <p>{training.intro}</p>
      {training.steps && (
        <>
          <p>Eğitim süresince aşağıdaki aşamalar tamamlanır:</p>
          <ul>
            {training.steps.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ul>
        </>
      )}
      <div className="it-video">
        {training.videoId ? (
          <YouTubeEmbed
            videoId={training.videoId}
            title={training.title}
            width="100%"
            height="100%"
          />
        ) : (
          <div className="it-video-soon">Eğitim videosu yakında yayınlanacaktır.</div>
        )}
      </div>
    </div>
  </InnerPage>
);

export default TrainingDetailPage;
